export const primary =  '#f85c24';
export const secondary =  '#f85c24';
